import Component from 'vue-class-component'
import PreviewComponenttVue from './PreviewComponent'
import { ImageData } from '../../store/editor/components/state'

type MenuMode = 'top' | 'link'

@Component
export default class ImageVue extends PreviewComponenttVue<ImageData> {

  get imageUrl(): string | undefined {
    return this.componentData._dataUrl
  }

  get linkUrl(): string | undefined {
    return this.componentData.linkUrl
  }

  get fileName(): string {
    return this.componentData.fileName
  }

  get imageElement(): string {
    if (this.isExternalBuild) {
      return `<es:content_detail_image file-name="${this.fileName}">`
        + `<img class="image-content__container__image" />`
        + `</es:content_detail_image>`
    }
    return `<img class="image-content__container__image" src="${this.imageUrl}" />`
  }
}
